import { React, useState } from "react";
import { useHistory } from "react-router-dom";
import IntegrationListView from "../integration/integration-list-view";
import HistoryIcon from "@mui/icons-material/History";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import BarChartIcon from "@mui/icons-material/BarChart";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ExtensionIcon from "@mui/icons-material/Extension";
import PhonelinkSetupIcon from "@mui/icons-material/PhonelinkSetup";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import { Moon, Sun } from "lucide-react";
import { useCustomTheme } from "../theme";
import { LightMode, DarkMode } from "@mui/icons-material";

import {
  Box,
  Card,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from "@mui/material";
// import { useTheme } from "@mui/material/styles";
import { useRecoilState } from "recoil";
import { platformState } from "../global-state";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";

const MenuCard = ({ icon: Icon, title, onClick }) => (
  <Card
    onClick={onClick}
    sx={{
      p: 2,
      bgcolor: "background.card",
      borderRadius: 2,
      cursor: "pointer",
      boxShadow: "none",
      transition: "transform 0.2s, box-shadow 0.2s",
      "&:hover": {
        transform: "scale(1.05)",
        boxShadow: "none",
      },
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Icon sx={{ mr: 1 }} />
        <Typography>{title}</Typography>
      </Box>
      <Box>
        <Typography sx={{ fontWeight: "bold" }}>&gt;</Typography>
      </Box>
    </Box>
  </Card>
);

const Menu = ({ showFilter, setShowFilter }) => {
  const history = useHistory();
  const [platform, setPlatform] = useRecoilState(platformState);

  const { mode, toggleTheme } = useCustomTheme();

  return (
    <Box
      sx={{
        padding: 2,
        height: "auto",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {/* Scope Section */}
        <Grid item xs={12} sm={6} md={4}>
          <MenuCard
            icon={MapsHomeWorkIcon}
            title="Space"
            onClick={() => history.push("/space")}
          />
        </Grid>

        {/*integration*/}
        <Grid item xs={12} sm={6} md={4}>
          <MenuCard
            icon={ExtensionIcon}
            title="Integrations"
            onClick={() => history.push("/integerations")}
          />
        </Grid>

        {/* Device Section */}
        <Grid item xs={12} sm={6} md={4}>
          <MenuCard
            icon={LightbulbOutlinedIcon}
            title="Device"
            onClick={() => history.push("/integration?id=basic.device")}
          />
        </Grid>

        {/* Phone Section */}
        {platform.source === "app" && (
          <Grid item xs={12} sm={6} md={4}>
            <MenuCard
              icon={PhonelinkSetupIcon}
              title="Phone Setting"
              onClick={() => history.push("/phone/setting")}
            />
          </Grid>
        )}

        {/* Hub Section */}
        <Grid item xs={12} sm={6} md={4}>
          <MenuCard
            icon={DeviceHubIcon}
            title="Hub Setting"
            onClick={() => history.push("/hub/setting")}
          />
        </Grid>

        {/* History Section */}
        <Grid item xs={12} sm={6} md={4}>
          <MenuCard
            icon={HistoryIcon}
            title="History"
            onClick={() => history.push("/automation/history")}
          />
        </Grid>

        {/* Schedule Section */}
        <Grid item xs={12} sm={6} md={4}>
          <MenuCard
            icon={ScheduleIcon}
            title="Schedule"
            onClick={() => history.push("/schedules")}
          />
        </Grid>

        {/* TaskFlowTempView Section */}
        <Grid item xs={12} sm={6} md={4}>
          <MenuCard
            icon={RecordVoiceOverIcon}
            title="Command Track"
            onClick={() => history.push("/commandtrack/list")}
          />
        </Grid>

        {/* Automation Statistics Section */}
        {process.env.NODE_ENV !== "production" && (
          <Grid item xs={12} sm={6} md={4}>
            <MenuCard
              icon={BarChartIcon}
              title="Automation Statistics"
              onClick={() => history.push("/automation/statistics")}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              py: 1,
              px: 2,
              bgcolor: "background.card",
              borderRadius: 2,
              boxShadow: "none",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "none",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {mode === "dark" ? <Moon /> : <Sun />}
                  <Box sx={{ ml: 1 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ color: "text.primary" }}
                    >
                      {mode === "dark" ? "Dark Theme" : "Light Theme"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                  value={mode}
                  onChange={toggleTheme}
                  displayEmpty
                  variant="outlined"
                  sx={{
                    bgcolor: "background.input",
                    "& .MuiSelect-select": {
                      py: 1,
                      px: 2,
                    },
                  }}
                >
                  <MenuItem value="light">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography>Light</Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="dark">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography>Dark</Typography>
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Menu;
